import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

function PercentageFormat(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      thousandSeparator
      isNumericString
      fixedDecimalScale
      decimalScale="2"
      suffix="%"
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value
          }
        });
      }}
      {...other}
    />
  );
}

PercentageFormat.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

export default PercentageFormat;
